// this will call into axis5 api
// axis5 api will be the middle man in between axis5 and deepdee\

import axios from "axios";
import { logDetailed } from "../../helpers/utils";

export const createDeepDeeExam = ({ commit }, payload) => {
  logDetailed("actions", "createDeepDeeExam");
  return axios.post("/api/deepdee/add", {
    ExSrNo: payload.ExSrNo,
    PtSrNo: payload.PtSrNo,
    FlName: payload.FlName,
    FileSrNo: payload.FileSrNo
  })
    .then(response => {
      if (response.data.status == 1000)  {
        logDetailed("actions", "createDeepDeeExam", "post failed. intermittent error.");
        commit("displayStatus", { message: "An intermittent error occurred. Please try again later", level: "error" });
        return Promise.resolve(response.data);
      }
      else if (response.data.status == 2000) {
        logDetailed("actions", "createDeepDeeExam", "post failed. analysis failed.");
        commit("displayStatus", { message: "Analysis failed. " + response.data.item.errorMessage, level: "error" });
        return Promise.resolve(response.data);
      }
      else {
        logDetailed("actions", "createDeepDeeExam", "post succeeded", response.data);
        return Promise.resolve(response.data);
      }
    })
    .catch(error => {
      logDetailed("actions", "createDeepDeeExam", "post failed");
      return Promise.reject(error.response);
    });
}

export const getDeepDeeExam = (state, payload) => {
  logDetailed("actions", "getDeepDeeExam");
  return axios.post("/api/deepdee/get", {
    ExSrNo: payload.ExSrNo,
    PtSrNo: payload.PtSrNo,
    FlName: payload.FlName,
    FileSrNo: payload.FileSrNo
  })
    .then(response => {
      logDetailed("actions", "getDeepDeeExam", "post succeeded", response.data);
      return Promise.resolve(response.data);
    })
    .catch(error => {
      logDetailed("actions", "getDeepDeeExam", "post failed");
      return Promise.reject(error.response);
    });
}